import React from 'react';
import './titlenumb.css'
const Titlenumb = ({ num, title, id  }) => {
    return ( 
        <article className='article-container-sec3'>
                <h1 className='header2-sec3' id={id}>{num}</h1>
                <h3 className='sentence-sec3'>{title}</h3>
        </article>
     );
}
 
export default Titlenumb;